import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import Header from "./Header.js";
import Sidebar from "./Sidebar.js";
//  import DataGridTable from "./common/DataGridTable";
import DynamicTable from "./common/DynamicTable.js";
import DynamicTiles from "./common/DynamicTiles.js";
import http from "../api/server.js";
import Footer from "./Footer.js";
import BottomBarIcons from "./BottomBarIcons.js";
import { GET_INSPECTION_DATA_SUMMARY_BY_CLIENT_ID } from "../api/apiPath.js";
import SidebarIcons from "./SidebarIcons.js";
import { useSelector } from "react-redux";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import LoadingComponent from "./common/LoadingComponent";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import useGetClientId from "../hooks/useGetClientId";

import propertyIcon from "../assets/img/newprop.png";
import usericon from "../assets/img/newuser.png";
import inspectionicon from "../assets/img/createInsp.png";
import leadicon from "../assets/img/tickets.png";
import reporticon from "../assets/img/reports.png";

const AdminDashboard = () => {
  const { userObj } = useSelector((state) => state.user);
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [searchTextProgress, setSearchTextProgress] = useState("");
  const [searchTextCompleted, setSearchTextCompleted] = useState("");
  const [propertyNameProgress, setPropertyNameProgress] =
    useState("Property Name");
  const [propertyNameCompleted, setPropertyNameCompleted] =
    useState("Property Name");
  const [InspectorProgress, setInspectorProgress] = useState("Inspector");
  const [InspectorCompleted, setInspectorCompleted] = useState("Inspector");
  const [statusProgress, setStatusProgress] = useState("Status");
  const [statusCompleted, setStatusCompleted] = useState("Status");
  const [date, setDate] = useState("Date");
  const [hideSidebar, setHideSidebar] = useState(true);
  const [progressSurveyData, setProgressSurveyData] = useState([]);
  const [completedSurveyData, setCompletedSurveyData] = useState([]);
  const [loading, setLoading] = useState(true);

  const clientObj = useGetClientId();

  const isAnyFilterAppliedOnProgress =
    searchTextProgress !== "" ||
    propertyNameProgress !== "Property Name" ||
    InspectorProgress !== "Inspector" ||
    statusProgress !== "Status";

  const isAnyFilterAppliedOnCompleted =
    searchTextCompleted !== "" ||
    propertyNameCompleted !== "Property Name" ||
    InspectorCompleted !== "Inspector" ||
    statusCompleted !== "Status" ||
    date !== "Date";

  useEffect(() => {
    if (clientObj.clientId) {
      fetchData();
    }
  }, [clientObj.clientId, clientObj.loading]);

  const fetchData = async () => {
    try {
      const response = await http.get(
        GET_INSPECTION_DATA_SUMMARY_BY_CLIENT_ID +
          clientObj?.clientId +
          "&userId=" +
          userObj?.userId
      ); //"E54D74F7-3367-4286-87AC-DD70C94B7B3E"
      if (response?.data) {
        setData(response?.data);
        // setProgressSurveyData(response?.data?.propertyFields);
        // setCompletedSurveyData(response?.data?.propertyFields);
        if (response?.data?.propertyFields) {
          const tempProgress = response?.data?.propertyFields;
          tempProgress?.forEach((item) => {
            item.id = item.propertyMasterId; // Assigning a sequential ID
          });
          console.log(
            tempProgress?.filter(
              (item) =>
                item.status === "In Progress" || item.status === "Scheduled"
            )
          );
          setProgressSurveyData(tempProgress);
          setCompletedSurveyData(
            tempProgress?.filter((item) => item.status === "Completed")
          );
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error fetching contact count:", error);
    }
  };

  const getProgressSurveyColumn = () => [
    {
      field: "propertyName",
      headerName: "PROPERTY NAME",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 1,
      renderCell: (params) => `${params.row.propertyName}`,
    },
    {
      field: "inspectedBy",
      headerName: "INSPECTOR",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
    },
    {
      field: "status",
      headerName: "STATUS",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) => {
        const status = params.value;
        const styles = {
          padding: "4px 12px",
          borderRadius: "12px",
          fontSize: "0.85rem",
          color: "#333",
          backgroundColor:
            status === "In Progress"
              ? "#FFE0B2"
              : status === "Scheduled"
              ? "#BBDEFB"
              : "#C8E6C9",
        };

        return <span style={styles}>{status}</span>;
      },
    },
  ];

  const getCompletedSurveyColumn = () => [
    {
      field: "propertyName",
      headerName: "PROPERTY NAME",
      headerClassName: "header-bold super-app-theme--header",
      sortable: false,
      flex: 0.5,
      renderCell: (params) => `${params.row.propertyName}`,
    },
    {
      field: "inspectedBy",
      headerName: "INSPECTOR",
      flex: 1,
      headerClassName: "header-bold super-app-theme--header",
    },

    {
      field: "lastInspectionDate",
      headerName: "Date",
      flex: 0.5,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) => {
        const rawDate = params.value;
        if (!rawDate) return "";

        const dateObj = new Date(rawDate);
        const formattedDate = dateObj.toLocaleDateString("en-GB"); // DD/MM/YYYY format

        return <span>{formattedDate}</span>;
      },
    },

    {
      field: "status",
      headerName: "STATUS",
      flex: 0.5,
      headerClassName: "header-bold super-app-theme--header",
      renderCell: (params) => {
        const status = params.value;
        const styles = {
          padding: "4px 12px",
          borderRadius: "12px",
          fontSize: "0.85rem",
          color: "#333",
          backgroundColor:
            status === "Completed"
              ? "#C8E6C9"
              : status === "Scheduled"
              ? "#BBDEFB"
              : "#FFE0B2",
        };

        return <span style={styles}>{status}</span>;
      },
    },
  ];

  const filteredRowsProgress = progressSurveyData.filter((row) => {
    const matchesSearch =
      !searchTextProgress ||
      row.propertyName
        ?.toLowerCase()
        .includes(searchTextProgress.toLowerCase()) ||
      row.status?.toLowerCase().includes(searchTextProgress.toLowerCase()) ||
      row.inspectedBy?.toLowerCase().includes(searchTextProgress.toLowerCase());

    const matchesPropertyNameProgress =
      propertyNameProgress === "Property Name" ||
      row.propertyName === propertyNameProgress;

    const matchesInspector =
      InspectorProgress === "Inspector" ||
      row.inspectedBy === InspectorProgress;

    const matchesStatus =
      statusProgress === "Status" || row.status === statusProgress;

    return (
      matchesSearch &&
      matchesPropertyNameProgress &&
      matchesInspector &&
      matchesStatus
    );
  });
  const filteredRowsCompleted = completedSurveyData.filter((row) => {
    const matchesSearch =
      !searchTextCompleted ||
      row.propertyName
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase()) ||
      row.status?.toLowerCase().includes(searchTextCompleted.toLowerCase()) ||
      row.lastInspectionDate
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase()) ||
      row.inspectedBy
        ?.toLowerCase()
        .includes(searchTextCompleted.toLowerCase());

    const matchesPropertyNameCompleted =
      propertyNameCompleted === "Property Name" ||
      row.propertyName === propertyNameCompleted;

    const matchesInspector =
      InspectorCompleted === "Inspector" ||
      row.inspectedBy === InspectorCompleted;

    const matchesStatus =
      statusCompleted === "Status" || row.status === statusCompleted;
    const matchDate =
      date === "Date" ||
      new Date(row.lastInspectionDate).toLocaleDateString("en-GB") === date;

    return (
      matchesSearch &&
      matchesPropertyNameCompleted &&
      matchesInspector &&
      matchesStatus &&
      matchDate
    );
  });

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <LoadingComponent loading={loading} />
      <div className="bg-light leadAdminDashboard min-vh-100">
        {/* Header */}

        {hideSidebar ? (
          <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar} />
        ) : (
          <SidebarIcons />
        )}
        <Container
          fluid
          className="mt-4 dashboard_body mx-2"
          style={{ marginTop: "123px !important", marginBottom: "75px" }} //paddingLeft: "120px", paddingRight: "50px" }}
        >
          {/* Stats Cards */}
          <Row className="mb-3" style={{ marginTop: "70px" }}>
            <Col md={true} sm={6} xs={12}>
              <div className="p-3 bg-white shadow-sm rounded text-center">
                <span style={{ fontSize: "48px", fontWeight: "600" }}>
                  {data?.adminApproverTotalInspections?.totalAvailablePoints ||
                    0}
                </span>
                <p className="mb-0">Total Available Points</p>
              </div>
            </Col>

            <Col md={true} sm={6} xs={12}>
              <div className="p-3 bg-white shadow-sm rounded text-center">
                <span style={{ fontSize: "48px", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalProperties || 0}
                </span>
                <p className="mb-0">Properties Onboarded</p>
              </div>
            </Col>

            <Col md={true} sm={6} xs={12}>
              <div className="p-3 bg-white shadow-sm rounded text-center">
                <span style={{ fontSize: "48px", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalSurveyInProgress || 0}
                </span>
                <p className="mb-0">Surveys In Progress</p>
              </div>
            </Col>
            <Col md={true} sm={6} xs={12}>
              <div className="p-3 bg-white shadow-sm rounded text-center">
                <span style={{ fontSize: "48px", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalSurveysCompleted || 0}
                </span>
                <p className="mb-0">Surveys Completed</p>
              </div>
            </Col>
            <Col md={true} sm={6} xs={12}>
              <div className="p-3 bg-white shadow-sm rounded text-center">
                <span style={{ fontSize: "48px", fontWeight: "600" }}>
                  {data?.adminDashboardInfos?.totalInspectors || 0}
                </span>
                <p className="mb-0">Inspectors</p>
              </div>
            </Col>
          </Row>
          <div className="p-3 rounded-4" style={{ backgroundColor: "#0b1a3b" }}>
            <Row className="g-3">
              {/* Generate Letter */}
              <Col>
                <div
                  className="d-flex flex-column align-items-center text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: "#1d2a4d" }}
                >
                  {/* <i
                    className="fa-solid fa-house-circle-check mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img src={propertyIcon} style={{height:'38px'}} className="mb-3" alt="Manage Property"/>
                  <h6 className="text-white fw-bold">Manage Property</h6>
                  <Button
                    variant="danger"
                    className="px-4 fw-semibold mt-3 red-button"
                    onClick={() => {
                      navigate(
                        generatePath("/client/:clientNameParam/addProperty", {
                          clientNameParam,
                        })
                      );
                    }}
                  >
                    Manage Property
                  </Button>
                </div>
              </Col>
              <Col>
                <div
                  className="d-flex flex-column align-items-center text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: "#1d2a4d" }}
                >
                  {/* <i
                    className="fa-solid fa-user-plus mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img src={usericon} style={{height:'38px'}} className="mb-3" alt="Manage User"/>
                  <h6 className="text-white fw-bold">Manage User</h6>
                  <Button
                    variant="danger"
                    className="px-4 fw-semibold mt-3 red-button"
                    onClick={() => {
                      navigate(
                        generatePath("/client/:clientNameParam/members", {
                          clientNameParam,
                        })
                      );
                    }}
                  >
                    Manage User
                  </Button>
                </div>
              </Col>
              <Col>
                <div
                  className="d-flex flex-column align-items-center text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: "#1d2a4d" }}
                >
                  {/* <i
                    className="fa-regular fa-clipboard mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img src={inspectionicon} style={{height:'38px'}} className="mb-3" alt="Manage inspection"/>
                  <h6 className="text-white fw-bold">Manage Inspection</h6>
                  <Button
                    variant="danger"
                    className="fw-semibold mt-3 red-button"
                    onClick={() => {
                      navigate(
                        generatePath(
                          "/client/:clientNameParam/inspectionDashboard",
                          {
                            clientNameParam,
                          }
                        )
                      );
                    }}
                  >
                    Manage Inspection
                  </Button>
                </div>
              </Col>
              <Col>
                <div
                  className="d-flex flex-column align-items-center text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: "#1d2a4d" }}
                >
                  {/* <i
                    className="fa-solid fa-ticket mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img src={leadicon} style={{height:'30px'}} className="mb-3 mt-2" alt="Manade leads"/>
                  <h6 className="text-white fw-bold">Manage Leads</h6>
                  <Button
                    variant="danger"
                    className="px-4 fw-semibold mt-3 red-button"
                    onClick={() => {
                      navigate(
                        generatePath("/client/:clientNameParam/leadDashboard", {
                          clientNameParam,
                        })
                      );
                    }}
                  >
                    Manage Leads
                  </Button>
                </div>
              </Col>
              <Col>
                <div
                  className="d-flex flex-column align-items-center text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: "#1d2a4d" }}
                >
                  {/* <i
                    className="fa-solid fa-chart-column mb-3 vividOrangeColor"
                    style={{ fontSize: "40px" }}
                  /> */}
                  <img src={reporticon} style={{height:'38px'}} className="mb-3" alt="Reports"/>
                  <h6 className="text-white fw-bold">Reports</h6>

                  <Button
                    variant="danger"
                    className="px-4 fw-semibold btn-danger mt-3 red-button"
                    onClick={() => {
                      // Handle report generation
                    }}
                  >
                    Reports
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <Row>
            <Col md={6}>
              <div className="dashboard-bar py-3">
                <h2 className="mt-3 mb-3 text-start fw-bold">
                  Survey Progress
                </h2>
                <div className="row align-items-center g-3 mt-3">
                  <div className="row">
                    <div className="custom_toolbar_search col-md-8">
                      <i
                        className="fa-solid fa-magnifying-glass"
                        style={{ left: "20px" }}
                      ></i>
                      <input
                        type="text"
                        className="form-control custom_toolbar_control"
                        id="floatingInput"
                        placeholder="Search..."
                        value={searchTextProgress}
                        onChange={(e) => setSearchTextProgress(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-6 col-md-4">
                    <select
                      className="form-select form-control"
                      value={propertyNameProgress}
                      onChange={(e) => setPropertyNameProgress(e.target.value)}
                    >
                      <option>Property Name</option>
                      {[
                        ...new Set(
                          progressSurveyData.map((user) => user.propertyName)
                        ),
                      ].map((propertyName, index) => (
                        <option key={index} value={propertyName}>
                          {propertyName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-6 col-md-3">
                    <select
                      className="form-select form-control"
                      value={InspectorProgress}
                      onChange={(e) => setInspectorProgress(e.target.value)}
                    >
                      <option value="Inspector">Inspector</option>
                      {[
                        ...new Set(
                          progressSurveyData.map((user) => user.inspectedBy)
                        ),
                      ].map((inspectorItem, index) => (
                        <option key={index} value={inspectorItem}>
                          {inspectorItem}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-6 col-md-3">
                    <select
                      className="form-select form-control"
                      value={statusProgress}
                      onChange={(e) => setStatusProgress(e.target.value)}
                    >
                      <option value="Status">Status</option>
                      {[
                        ...new Set(
                          progressSurveyData.map((user) => user.status)
                        ),
                      ].map((statusItem, index) => (
                        <option key={index} value={statusItem}>
                          {statusItem}
                        </option>
                      ))}
                    </select>
                  </div>
                  {isAnyFilterAppliedOnProgress && (
                    <div style={{ width: "auto", paddingLeft: "0px" }}>
                      <IconButton
                        tabIndex={0}
                        title="Clear Filters"
                        onClick={() => {
                          setSearchTextProgress("");
                          setPropertyNameProgress("Property Name");
                          setInspectorProgress("Inspector");
                          setStatusProgress("Status");
                        }}
                      >
                        <ClearIcon sx={{ color: "#EF3800" }} fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="inspection-table">
                <DynamicTable
                  tableData={filteredRowsProgress}
                  columnsValue={getProgressSurveyColumn()}
                  showSelectAll={false}
                  //handleCheckBoxSelection={handleMultipleUserDelete}
                  pageSize={10}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                />
              </div>
              <div className="inspection-tile">
                {filteredRowsProgress &&
                  filteredRowsProgress?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <DynamicTiles
                        tableData={item}
                        module="adminDashboardProgress"
                      />
                    );
                  })}
              </div>
            </Col>
            <Col md={6}>
              <div className="dashboard-bar py-3">
                <h2 className="mt-3 mb-3 text-start fw-bold">
                  Survey Completed
                </h2>
                <div className="row align-items-center g-3 mt-3">
                  {/* Search Bar */}
                  <div className="row">
                    <div className="custom_toolbar_search col-md-8 ">
                      <i
                        className="fa-solid fa-magnifying-glass"
                        style={{ left: "20px" }}
                      ></i>
                      <input
                        type="text"
                        className="form-control custom_toolbar_control"
                        id="floatingInput"
                        placeholder="Search..."
                        value={searchTextCompleted}
                        onChange={(e) => setSearchTextCompleted(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Dropdowns */}
                  <div className="col-6 col-md-4">
                    <select
                      className="form-select form-control"
                      value={propertyNameCompleted}
                      onChange={(e) => setPropertyNameCompleted(e.target.value)}
                    >
                      <option>Property Name</option>
                      {[
                        ...new Set(
                          completedSurveyData.map((user) => user.propertyName)
                        ),
                      ].map((propertyName, index) => (
                        <option key={index} value={propertyName}>
                          {propertyName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-6 col-md-3">
                    <select
                      className="form-select form-control"
                      value={InspectorCompleted}
                      onChange={(e) => setInspectorCompleted(e.target.value)}
                    >
                      <option value="Inspector">Inspector</option>
                      {[
                        ...new Set(
                          completedSurveyData.map((user) => user.inspectedBy)
                        ),
                      ].map((inspectorItem, index) => (
                        <option key={index} value={inspectorItem}>
                          {inspectorItem}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-2">
                    <select
                      className="form-select form-control"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    >
                      <option value="Date">Date</option>
                      {[
                        ...new Set(
                          completedSurveyData.map(
                            (user) => user.lastInspectionDate
                          )
                        ),
                      ].map((dateItem, index) => {
                        if (!dateItem) return null;
                        const dateObj = new Date(dateItem);
                        const formattedDate =
                          dateObj.toLocaleDateString("en-GB");
                        return (
                          <option key={index} value={formattedDate}>
                            {formattedDate}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-6 col-md-3" style={{ width: "17.99%" }}>
                    <select
                      className="form-select form-control"
                      value={statusCompleted}
                      onChange={(e) => setStatusCompleted(e.target.value)}
                    >
                      <option value="Status">Status</option>
                      {[
                        ...new Set(
                          completedSurveyData.map((user) => user.status)
                        ),
                      ].map((statusItem, index) => (
                        <option key={index} value={statusItem}>
                          {statusItem}
                        </option>
                      ))}
                    </select>
                  </div>
                  {isAnyFilterAppliedOnCompleted && (
                    <div style={{ width: "auto", paddingLeft: "0px" }}>
                      <IconButton
                        tabIndex={0}
                        title="Clear Filters"
                        onClick={() => {
                          setSearchTextCompleted("");
                          setPropertyNameCompleted("Property Name");
                          setInspectorCompleted("Inspector");
                          setStatusCompleted("Status");
                          setDate("Date");
                        }}
                      >
                        <ClearIcon sx={{ color: "#EF3800" }} fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="inspection-table">
                <DynamicTable
                  tableData={filteredRowsCompleted}
                  columnsValue={getCompletedSurveyColumn()}
                  showSelectAll={false}
                  //handleCheckBoxSelection={handleMultipleUserDelete}
                  pageSize={10}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                />
              </div>
              <div className="inspection-tile">
                {filteredRowsCompleted &&
                  filteredRowsCompleted?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <DynamicTiles
                        tableData={item}
                        module="adminDashboardCompleted"
                      />
                    );
                  })}
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
        <div className="bottom-bar-spacing"></div>
        <BottomBarIcons />
      </div>
    </>
  );
};
export default AdminDashboard;
